import styled from 'styled-components/macro';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 35px;
  height: 35px;
  margin-bottom: 20px;
`;

export default Wrapper;
